import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class BrokerChargeUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.brokerCharge(req);
    }
}
export default BrokerChargeUseCase;
